@if (pvBlocks().length) {
  <xemex-card [title]="'installations.attributes.pvForecast.title' | translate">
    <div class="flex flex-col gap-4">
      @if (devices().length > 1 && selectedDeviceId(); as deviceId) {
        <xemex-installation-device-select
          label="installations.attributes.pvForecast.deviceSelect"
          [installationOid]="installation().installationOid"
          [devices]="devices()"
          [selected]="deviceId"
          (selectedChange)="selectedDeviceId.set($event)"
        />
      }

      @if (selectedBlock(); as block) {
        <div class="flex flex-col gap-3" data-testid="pv-forecast-block">
          <div class="flex flex-wrap items-center justify-between gap-2">
            <a
              class="text-sm font-medium text-text-default hover:underline"
              [routerLink]="['/', APP_PATHS.Devices, block.deviceId, 'general']"
              >{{ block.ldn }}</a
            >
            @if (!block.editable && block.configured && !block.message) {
              <xemex-tag
                [state]="block.active ? 'success' : 'neutral'"
                [label]="
                  'installations.attributes.pvForecast.' + (block.active ? 'active' : 'inactive')
                    | translate
                "
              />
            }
          </div>

          @if (block.message) {
            <p class="text-sm text-text-secondary">{{ block.message }}</p>
          } @else if (block.inPlace) {
            @if (block.configured) {
              <ng-container *ngTemplateOutlet="activeSwitch; context: { $implicit: block }" />
            }

            @if (editor(); as editor) {
              <xemex-pv-forecast-form [form]="editor.form" [emeterChannels]="editor.channels" />

              <div class="flex justify-end">
                <xemex-filled-button
                  data-testid="save-pv-forecast"
                  [disabled]="!canSave()"
                  [loading]="saving()"
                  (click)="save()"
                >
                  {{ 'general.btnSave' | translate }}
                </xemex-filled-button>
              </div>
            } @else if (channelsFailed()) {
              <div class="flex flex-wrap items-center justify-between gap-2">
                <p class="m-0 text-sm text-text-error" role="alert" data-testid="pv-channels-error">
                  {{ 'installations.attributes.pvForecast.errors.channelsFailed' | translate }}
                </p>
                <xemex-text-button data-testid="retry-pv-channels" (click)="retryChannels()">
                  {{ 'general.btnTryAgain' | translate }}
                </xemex-text-button>
              </div>
            } @else {
              <xemex-skeleton-block height="160px" borderRadius="8px" />
            }
          } @else if (block.editable && block.deviceLoading) {
            <xemex-skeleton-block height="160px" borderRadius="8px" />
          } @else if (!block.configured) {
            <span class="text-sm text-text-secondary">
              {{ 'installations.attributes.pvForecast.notSetUp' | translate }}
            </span>
            @if (block.productionOnly) {
              <p class="m-0 text-sm text-text-secondary" data-testid="pv-production-only">
                {{ 'devices.pvForecast.enable.productionOnly' | translate }}
              </p>
            }
          } @else {
            @if (block.editable) {
              <ng-container *ngTemplateOutlet="activeSwitch; context: { $implicit: block }" />
            }

            <xemex-detail-field [label]="'installations.attributes.pvForecast.channel' | translate">
              {{ block.channel }}
            </xemex-detail-field>

            @for (array of block.arrays; track $index) {
              <div class="flex items-start justify-between gap-4 text-sm">
                <span class="font-medium text-text-default">
                  {{ 'devices.pvForecast.dialog.arrayTitle' | translate: { number: $index + 1 } }}
                </span>
                <div class="flex flex-col items-end gap-0.5 text-right text-text-secondary">
                  <span>{{
                    'devices.pvForecast.summaryTilt' | translate: { value: array.tilt }
                  }}</span>
                  <span>
                    {{
                      'devices.pvForecast.summaryOrientation'
                        | translate: { value: array.orientation }
                    }}
                  </span>
                  <span>{{
                    'devices.pvForecast.summaryKwp' | translate: { value: array.kwp }
                  }}</span>
                </div>
              </div>
            }

            <xemex-detail-field [label]="'installations.attributes.pvForecast.total' | translate">
              {{ 'devices.pvForecast.summaryKwp' | translate: { value: block.totalKwp } }}
            </xemex-detail-field>
          }

          @if (block.errorKey) {
            <p class="m-0 text-sm text-text-error" role="alert" data-testid="pv-forecast-error">
              {{ block.errorKey | translate }}
            </p>
          }
        </div>
      } @else if (selectedLoading()) {
        <xemex-skeleton-block height="48px" borderRadius="8px" />
      } @else {
        <p class="m-0 text-sm text-text-secondary" data-testid="pv-forecast-none">
          {{ 'installations.attributes.pvForecast.notSetUp' | translate }}
        </p>
      }
    </div>
  </xemex-card>
}

<ng-template #activeSwitch let-block>
  <div class="flex items-start justify-between gap-4">
    <div class="flex flex-col gap-1">
      <span class="text-sm font-medium">
        {{ 'devices.pvForecast.enable.label' | translate }}
      </span>
      <span class="text-sm text-text-secondary">
        {{ 'installations.attributes.pvForecast.enableDescription' | translate }}
      </span>
      @if (block.productionOnly && !block.active) {
        <span class="text-sm text-text-secondary" data-testid="pv-production-only">
          {{ 'devices.pvForecast.enable.productionOnly' | translate }}
        </span>
      }
    </div>
    <mat-slide-toggle
      data-testid="pv-active-toggle"
      [checked]="block.active"
      [disabled]="block.busy || (block.enableBlocked && !block.active)"
      (change)="toggle(block.deviceId, $event)"
    />
  </div>
  <div class="border-t border-border-default"></div>
</ng-template>
